/**
 * "2 hours ago", "Yesterday" — near enough for a list nobody reads twice.
 *
 * Shared by the bell and by the notices card on the teacher's overview: both
 * date the same rows, and two spellings of "yesterday" on one screen reads as a
 * bug (CLAUDE.md §3).
 */
export function timeAgo(iso: string): string {
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60_000);

  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes} min ago`;

  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;

  const days = Math.round(hours / 24);
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} days ago`;

  return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
}
